export default "__VITE_ASSET__CpN2thSW__"